import permissions from 'src/data/permissions.json';
import { useAppSelector } from 'src/store';
import { ISFUI } from 'src/types/KeyCloak';
import { useUser } from './useUser';

export const usePermissionWrapper = () => {
  const { roles } = useUser();
  const userdocpermissions: any = useAppSelector(state => state.user.user?.userdocpermissions);
  const checkPermission = (access: string) => {
    const found = permissions.access.find(item => item.key === access);
    return found && roles?.includes(found.permission as ISFUI);
  };

  const checkPermissionDocViewLevel = (access: string, permissionLevel: string) => {
    const found = permissions.access_api.find(item => item.key === access);
    return (found && userdocpermissions?.includes(found.permission)) || userdocpermissions?.includes('ALL');
  };
  return { checkPermission, checkPermissionDocViewLevel };
};
